import {NgModule} from "@angular/core";
import {WidgetSaldoInfoComponent} from "./widget-saldo-info/widget-saldo-info.component";
import {PaySaldoService} from "./pay-saldo.service";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {WidgetStatusComponent} from "./widgetStatus/widget-status.component";
import {NewWidgetSaldoInfoComponent} from "./new-widget-saldo-info/new-widget-saldo-info.component";
import {ModalModule} from "ngx-bootstrap";
import {PaymentUserDataAdapter} from "./models/payment-user-data";
import {SharedModule} from "../../shared-module/shared.module";
/**
 * Created by K.Lapihin on 19.03.2018.
 */
@NgModule({
  declarations: [
    WidgetSaldoInfoComponent,
    WidgetStatusComponent,
    NewWidgetSaldoInfoComponent
  ],
  exports: [
    WidgetSaldoInfoComponent,
    WidgetStatusComponent,
    NewWidgetSaldoInfoComponent
  ],
  providers: [
    PaySaldoService,
    PaymentUserDataAdapter
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    SharedModule,
  ],
})
export class WidgetHelperModule {

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/widget-saldo-info.module.ts